import { apiTypeHelper } from '@/base/network'

export const CREATE_EMPLOYEE = apiTypeHelper('CREATE_EMPLOYEE')
export const LIST_MANAGERS = apiTypeHelper('LIST_MANAGERS')
export const LIST_EMPLOYEE = apiTypeHelper('LIST_EMPLOYEE')
export const LIST_SALES = apiTypeHelper('LIST_SALES')
export const GET_EMPLOYEES_COUNT_SUMMARY = apiTypeHelper('GET_EMPLOYEES_COUNT_SUMMARY')
export const DELETE_EMPLOYEE = apiTypeHelper('DELETE_EMPLOYEE')
export const GET_EMPLOYEE_PROFILE = apiTypeHelper('GET_EMPLOYEE_PROFILE')